export default "__VITE_ASSET__8cc2712d__"